import Vue from 'vue'
import { utils } from '../utils'

function makeLoaders(collections) {
  const loaders = {}
  for (const c of collections) {
    let name
    let url
    let field
    if (typeof c === 'string')
      name = url = field = c
    else {
      name = c.name
      url = c.url || c.name
      field = c.field
    }

    if (field === undefined) field = name

    loaders[`load_${name}`] = function ({ commit }, that) {
      return Vue.http.get(url)
        .then(r => {
          let data = r.body
          if (field) {
            data = {
              [field]: data,
            }
          }
          commit('LOAD_SUMMARY', data)
          if (data.contracts || name === 'customers')
            commit('COMPUTE_CUSTOMER_CONTRACTS')
          console.log(`[StoreLoader] ${name} loaded!`, r)
        })
        .catch((...args) => {
          utils.DefaultErrorHandler.call(that, ...args)
        })
    }
  }
  return loaders
}

export default {
  ...makeLoaders(
    [{
      name: 'summary',
      field: null,
    },
    'customers',
    'properties',
    'preorders',
    'bills',
    'rooms',
    'meter_records',
    'charges',
    'roles',
    {
      name: 'subjectstree',
      url: 'bills/subjectstree',
      field: 'subjectstree',
    },
    {
      name: 'balance',
      url: 'report/balance',
      field: 'balance',
    },
    {
      name: 'meta',
      url: 'meta',
      field: 'meta',
    },
    ]
  ),
}



// WEBPACK FOOTER //
// ./client/src/store/actions.js